<template>
  <div>
    <div class="ra-fund--wallet">
      <div class="balance">
        <span>Balance</span>
        <h6>{{ formatPrice(walletBalance) }}</h6>
      </div>
      <div
        v-if="userCan('payment', 'payment.init')"
        class="fund"
        @click="showFundWallet = true"
      >
        <i class="ra-icon--plus"></i>
      </div>
    </div>
    <fund-wallet :show.sync="showFundWallet" />
  </div>
</template>

<script>
export default {
  name: "FundWalletCta",
  components: {
    FundWallet: () => import("@/components/Wallet/Fund.vue")
  },
  data() {
    return {
      showFundWallet: false
    };
  },
  computed: {
    walletBalance() {
      return this.$store.getters.wallet.balance;
    }
  }
};
</script>

<style lang="scss">
.ra-fund--wallet {
  background: #36afa4;
  position: fixed;
  padding: 10px;
  border-radius: 8px;
  box-shadow: -8px 32px 50px rgba(0, 0, 0, 0.08);
  right: 20px;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9;

  .balance {
    display: flex;
    align-items: center;
    margin-right: 30px;

    h6,
    span {
      color: #fff;
    }

    h6 {
      font-size: 1rem;
    }
    span {
      font-size: 12px;
      margin-right: 10px;
    }
  }

  .fund {
    border-radius: 100%;
    background: #ffffff;
    color: #36afa4;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;

    i {
      font-size: 0.875rem;
    }
  }
}
</style>
